import {
  ADD_AWARD_NOMINATION_REQUEST,
  CREATE_ORDER_AWARD_NOMINATION_REQUEST,
  GET_AWARD_DETAILS_REQUEST,
  GET_AWARDS_LIST_REQUEST,
  GET_AWARDS_CATEGORY_LIST_REQUEST,
  GET_NOMINATION_DETAILS_REQUEST,
  GET_NOMINATION_LIST_REQUEST,
  UPDATE_NOMINATION_REQUEST,
  VERIFY_AWARD_NOMINATION_PAYMENT_REQUEST,
  ADD_AWARD_SHORTLISTED_DETAILS_REQUEST,
  ADD_AWARD_REQUEST,
  UPDATE_AWARD_REQUEST,
  ADD_AWARD_CATEGORY_REQUEST,
  UPDATE_AWARD_CATEGORY_REQUEST,
} from "../types/awards"

// Users
export const getAwardDetails = data => ({
  type: GET_AWARD_DETAILS_REQUEST,
  payload: { data },
})

export const addAwardNomination = data => ({
  type: ADD_AWARD_NOMINATION_REQUEST,
  payload: { data },
})

export const createOrderAwardNomination = data => ({
  type: CREATE_ORDER_AWARD_NOMINATION_REQUEST,
  payload: { data },
})

export const verifyAwardNominationPayment = data => ({
  type: VERIFY_AWARD_NOMINATION_PAYMENT_REQUEST,
  payload: { data },
})

export const addAwardShortlistedDetails = data => ({
  type: ADD_AWARD_SHORTLISTED_DETAILS_REQUEST,
  payload: { data },
})

// Admin
export const getAwardsList = data => ({
  type: GET_AWARDS_LIST_REQUEST,
  payload: { data },
})

export const getNominationList = data => ({
  type: GET_NOMINATION_LIST_REQUEST,
  payload: { data },
})

export const getNominationDetails = data => ({
  type: GET_NOMINATION_DETAILS_REQUEST,
  payload: { data },
})

export const getAwardsCategoryList = data => ({
  type: GET_AWARDS_CATEGORY_LIST_REQUEST,
  payload: { data },
})

export const updateNomination = data => ({
  type: UPDATE_NOMINATION_REQUEST,
  payload: { data },
})

export const addAward = data => ({
  type: ADD_AWARD_REQUEST,
  payload: { data },
})

export const updateAward = data => ({
  type: UPDATE_AWARD_REQUEST,
  payload: { data },
})

export const addAwardCategory = data => ({
  type: ADD_AWARD_CATEGORY_REQUEST,
  payload: { data },
})

export const updateAwardCategory = data => ({
  type: UPDATE_AWARD_CATEGORY_REQUEST,
  payload: { data },
})
